import { useState } from 'react';
import useFetch, { CachePolicies } from 'use-http';

import { API_ROUTES, ERROR_CODES } from '../../../constants';
import { TAPIResponse } from '../../../api.types';

export type TAPIIdentityApplicationNameResponse = {
  isUnique: boolean;
};

export type TAPIResponseIdentityApplicationName = TAPIResponse & {
  identityApplicationName(
    applicationName: string
  ): Promise<TAPIIdentityApplicationNameResponse>;
};

export const useAPIIdentityApplicationName =
  (): TAPIResponseIdentityApplicationName => {
    const [responseData, setResponseData] =
      useState<TAPIIdentityApplicationNameResponse>({ isUnique: false });
    const { get, response, loading, error } = useFetch(API_ROUTES.DEVELOPERS, {
      cachePolicy: CachePolicies.NO_CACHE,
    });
    async function identityApplicationName(
      applicationName: string
    ): Promise<TAPIIdentityApplicationNameResponse> {
      const serverResponse = await get(
        `4260fb56-2b5b-4e4d-8ac0-37d42adccc13/check-application-name?app_name=${applicationName}`
      );

      const isUnique = serverResponse.data.code !== ERROR_CODES.APPLICATION_ALREADY_EXIST
      if (response.ok) {
        setResponseData({ isUnique });
      }

      return Promise.resolve({ isUnique });
    }

    return {
      loading,
      error,
      data: responseData,
      loaded: response.ok,
      identityApplicationName,
    };
  };
